<template>
  <div class="img-holder">
    <p class="animated fadeInUp h-paragraph-small h-text-just">{{ $t(desc) }}</p>
    <div
      v-for="(image, imageIndex) in images.full"
      :key="imageIndex"
      class="animated fadeInUp photo"
      :alt="image.title"
      :style="{ backgroundImage: 'url(' + image.medium_srcset.split(' ')[0] + ')' }"
      @click="index = imageIndex, noScroll()"
    ></div>
    <gallery :images="images.largeImages" :index="index" @close="index = null, noScroll()"></gallery>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  data: function() {
    return {
      index: null
    };
  },
  components: {
    gallery: VueGallery
  },
  computed: {
    images() {
      const images = this.$store.getters.getAllActiveImages;
      return images;
    },
    desc() {
      return this.$store.getters.getDescription;
    }
  },
  methods: {
    noScroll() {
      if (this.index) {
        document.getElementsByClassName("header")[0].style.display = "none";
        document.getElementsByTagName("html")[0].style.overflowY = "hidden";
      } else {
        document.getElementsByClassName("header")[0].style.display = "flex";
        document.getElementsByTagName("html")[0].style.overflowY = "visible";
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch("resetActive");
  }
};
</script>

<style lang='scss'>
.img-holder {
  width: 100%;
  padding-top: 5rem;
  @include flex(flex-start, flex-start, row);
  flex-wrap: wrap;
  @include respond(tab-land) {
    width: auto;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-content: center;
    flex-wrap: wrap;
    align-items: center;
  }
  @include respond(phone) {
    padding: 0;
    // display: block;
  }
}
.photo {
  height: 20rem;
  width: 30%;
  margin-right: 5px;
  margin-bottom: 5px;
  transition: 300ms;
  background-size: cover;
  background-position: center 17%;
  background-repeat: no-repeat;
  &:hover {
    transform: scale(1.03);
    cursor: pointer;
  }
  @include respond(phone) {
    width: 42%;
    margin: 0 auto 10px;
  }
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>